import { render } from "./TrendDelta.vue?vue&type=template&id=7d09fb2f&scoped=true"
import script from "./TrendDelta.vue?vue&type=script&lang=js"
export * from "./TrendDelta.vue?vue&type=script&lang=js"

import "./TrendDelta.vue?vue&type=style&index=0&id=7d09fb2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d09fb2f"]])

export default __exports__